import { Checkbox } from "@povio/ui";
import type { Key } from "react-aria-components";
import { useTranslation } from "react-i18next";

import type { DropdownProps, MultiDropdownProps } from "./Dropdown";

type Props<TKey extends Key = Key> = Pick<MultiDropdownProps<TKey>, "onChange" | "value"> &
  Pick<DropdownProps<TKey>, "items">;

export const DropdownListBoxAllOption = <TKey extends Key = Key>({ onChange, value, items }: Props<TKey>) => {
  const { t } = useTranslation();

  return (
    <div className="border-secondary-75 border-b px-4 py-2">
      <Checkbox
        className="cursor-pointer"
        onChange={(isChecked) => {
          if (isChecked) {
            onChange(items.map((item) => item.id));
            return;
          }

          onChange([]);
        }}
        isSelected={value.length === items.length}
        isIndeterminate={value.length > 0 && value.length < items.length}
      >
        {t("ui.dropdown.allOption")}
      </Checkbox>
    </div>
  );
};
